<script lang="ts" setup></script>

<template>
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13 17H15C15.5304 17 16.0391 16.7893 16.4142 16.4142C16.7893 16.0391 17 15.5304 17 15C17 14.4696 16.7893 13.9609 16.4142 13.5858C16.0391 13.2107 15.5304 13 15 13H12C11.4 13 10.9 13.2 10.6 13.6L5 19"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9 23L10.6 21.6C10.9 21.2 11.4 21 12 21H16C17.1 21 18.1 20.6 18.8 19.8L23.4 15.4C23.7859 15.0354 24.0111 14.5323 24.0261 14.0016C24.0411 13.4709 23.8447 12.9559 23.48 12.57C23.1153 12.1841 22.6123 11.9589 22.0816 11.9439C21.5508 11.9289 21.0359 12.1254 20.65 12.49L16.45 16.39"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path d="M4 18L10 24" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		<path
			d="M18 13.9C19.6016 13.9 20.9 12.6016 20.9 11C20.9 9.39835 19.6016 8.09998 18 8.09998C16.3983 8.09998 15.1 9.39835 15.1 11C15.1 12.6016 16.3983 13.9 18 13.9Z"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<style scoped lang="scss"></style>
